import './BranchName-2fad4f4b.css';

var classes = {"BranchName":"prc-BranchName-BranchName-jFtg-"};

export { classes as default };
